import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import WhatWeDo from './pages/WhatWeDo';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import FloatingButtons from './components/WhatsAppBtn';
import Canonical from './components/Canonical';

const theme = {
  colors: {
    primary: '#1a4d80',
    secondary: '#f39c12',
    accent: '#e74c3c',
    dark: '#2c3e50',
    light: '#ecf0f1',
    white: '#ffffff',
    gray: '#95a5a6',
    darkGray: '#34495e'
  },
  fonts: {
    primary: "'Poppins', sans-serif",
    secondary: "'Roboto', sans-serif"
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px'
  }
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Canonical />
        <div className="App">
          <Header />
          <FloatingButtons/>
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
